module.exports = __webpack_public_path__ + "img/small-info.bc3f160a.svg";